import React, { useState } from 'react'
import ArrowUp from '../../../assets/images/arrow_up_black.svg'
import ArrowDown from '../../../assets/images/arrow_down_black.svg'
import Loading from './Loading';
import FooterCode from "../Logic/FooterLogic"
import ReadVerseModal from '../../Modals/Logic/ReadVerseModal'
import { verseArabicForDisplay, verseArabicWordClassName, VERSE_END_MARKER_FONT_FAMILY } from '../../../assets/js/verseScriptText'

export default function Search(props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedVerse, setSelectedVerse] = useState(null);

    const handleVerseClick = (singleVerse) => {
        console.log("singleVerse", singleVerse);
        setSelectedVerse(singleVerse);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedVerse(null);
    };

    // Check if there are any actual search results
    const hasResults = props.searchResult && Array.isArray(props.searchResult) && props.searchResult.length > 0;
     // Show "no results" if loading is done and there are no actual verse results
    const shouldShowNoResults = !props.loading && !hasResults;

    return (
        <div className="">
            {props.loading && <Loading />}
            <div className="d-flex flex-column padding-search-section-4-1 py-4 page-wrap">
                {shouldShowNoResults ? (
                    <div className="d-flex flex-column align-items-center justify-content-center py-5">
                        <label className="font-size-16-400 text-muted text-white-black-2-theme py-4">
                            {props.t ? props.t('no-search-results-found') : 'No results found'}
                        </label>
                    </div>
                ) : (
                    <>
                {props.rootWordSearch &&
                    props.searchRootWordResult &&
                    props.searchRootWordResult.length > 0 && (
                        <div className="search-rood-container mb-1" dir="ltr">
                            <div className="search-root-actions" dir="ltr">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm search-select-deselect-btn"
                                    onClick={props.onSelectAllSections}
                                >
                                    {props.t ? props.t('select-all') : 'Select All'}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm search-select-deselect-btn"
                                    onClick={props.onDeselectAllSections}
                                >
                                    {props.t ? props.t('deselect-all') : 'Deselect All'}
                                </button>
                            </div>
                            <div className="search-root-keywords" dir="ltr">
                                {props.searchRootWordResult.map((word, index) => (
                                    <label
                                        key={index + "S3"}
                                        onClick={() => props.toggleDivVisibility(index)}
                                        className={`search-root-chip font-size-16-400 p-2 ${props.rootWordDivVisibility[index] ? 'bg-color-gray4' : 'bg-color-gray3'
                                            }`}
                                        role="button"
                                        dir="rtl"
                                    >
                                        {word}
                                    </label>
                                ))}
                            </div>
                        </div>
                    )
                }
                {props.searchRootWordResult && props.searchRootWordResult.length > 0 && hasResults && (
                    <div>
                        {props.searchRootWordResult.map((word, index) => (
                            <div key={index + "S4"}
                                className={`d-flex flex-column padding-search-section-4 mt-4 ${props.rootWordDivVisibility[index] ? '' : 'd-none'
                                    }`}
                            >
                                <div
                                    className={`d-flex flex-column my-1 ${props.expandedSections.includes(index) ? 'search-container-expand' : ''
                                        }`}
                                >
                                    <div onClick={() => props.toggleSearchResultVisibility(index, word)} className="px-4 w-100 search-title-container-expand cursor-pointer">
                                        <label className="font-size-15-400 m-0 padding-word-x-3 cursor-pointer ">
                                            <strong className="search-strong ">{word}</strong>
                                            {props.sectionSearchResultsVisibility.includes(index) && props.occurance !== 0 ? (<span> {props.t ? props.t('occurrences') : 'Occurrences'}: {props.occurance}</span>) : null}
                                        </label>
                                        <img
                                            className="size-20-25 ml-3"
                                            alt=""
                                            src={props.expandedSections.includes(index) ? ArrowUp : ArrowDown}
                                        />
                                    </div>
                                    <div className="d-flex flex-column py-2 w-100">
                                        {props.sectionSearchResultsVisibility.includes(index) && (
                                            <div className="d-flex flex-column p-4 search-data-container">
                                                {props.searchResult && props.searchResult.length > 0 && (
                                                    props.searchResult.map((singleVerse, index) => {
                                                        const isLastIndex = index === props.searchResult.length - 1;
                                                        return (
                                                            <div key={index + "S1"} className={`d-flex flex-row  ${isLastIndex ? '' : 'border-bottom'}`}>
                                                                <div className="d-flex flex-row w-100 pl-3 py-3">
                                                                    <label
                                                                        className="word_count_text px-1 specialAreaColor text-white-black-theme align-self-start"
                                                                        style={{
                                                                            minWidth: "auto",   // enough for 10 characters, adjust as needed
                                                                            maxWidth: "12ch",
                                                                            flexShrink: 0,
                                                                            marginRight: "1rem",
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={() => handleVerseClick(singleVerse)}
                                                                    >
                                                                        {singleVerse.chapterNo}:{singleVerse.verseNo}
                                                                    </label>
                                                                    <div className="d-flex flex-row-reverse justify-content-start py-2 flex-wrap" style={{ flex: 1, minWidth: 0 }}>
                                                                        {verseArabicForDisplay(props.scriptStyle, singleVerse).split(" ").map((splitedWord, index) => {
                                                                            const searchWords = props.removeDiacritics(word.toUpperCase())
                                                                                .trim()
                                                                                .split(" ");

                                                                            // Condition 1: full match check against any search word
                                                                            const matchCondition1 = searchWords.some(searchWord =>
                                                                                props.compareStrings(
                                                                                props.removeDiacritics(splitedWord.toUpperCase()).trim(),
                                                                                searchWord
                                                                                ) === true
                                                                            );

                                                                            // Condition 2: partial letter match against any search word
                                                                            const matchCondition2 = searchWords.some(searchWord =>
                                                                                Array.from(searchWord).every((letter) =>
                                                                                props.removeDiacritics(splitedWord).includes(
                                                                                    props.removeDiacritics(letter.toUpperCase())
                                                                                )
                                                                                )
                                                                            );

                                                                            const allLettersMatched = matchCondition1 || matchCondition2;

                                                                            return (
                                                                                <div
                                                                                key={index + "S2"}
                                                                                className={`${props.scriptStyle} ${verseArabicWordClassName(props.scriptStyle)} text-right w-auto align-self-center pl-2 cursor-pointer ${
                                                                                    allLettersMatched ? "txt-color-pink" : "text-darker"
                                                                                }`}
                                                                                style={{ fontSize: props.arabicFontSize + "rem" }}
                                                                                onClick={() => handleVerseClick(singleVerse)}
                                                                                >
                                                                                {splitedWord}
                                                                                </div>
                                                                            );
                                                                        })}

                                                                        <label
                                                                            className="text-right w-auto align-self-center simple-font-family verse_end medium-aya-font"
                                                                            role="button"
                                                                            style={{ fontSize: 14, fontFamily: VERSE_END_MARKER_FONT_FAMILY }}
                                                                            onClick={() => handleVerseClick(singleVerse)}
                                                                        >
                                                                            {' \uFD3E' +
                                                                                singleVerse.verseNo.toLocaleString('ar-EG') +
                                                                                '\uFD3F'}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                )}
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                    </>
                )}
            </div>
            <FooterCode />
            <ReadVerseModal 
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                singleVerse={selectedVerse}
            />
        </div>
    );
}